export default "__VITE_ASSET__Un5mtRyw__"